<template>
    <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
        <div slot="modal-header" class="w-100">
            <h5>Visit Cash/Check Payment<button type="button" class="close"
                                      @click.prevent="closeModal()">
                <span aria-hidden="true">&times;</span></button>
            </h5>
        </div>
      <b-form>
        <div class="container-fluid">
          <div class="row justify-content-center m-2">
            <div class="alert alert-danger col" role="alert" v-show="generalErrorMessage">
              <div>{{ generalErrorMessage }}</div>
            </div>
          </div>
          <div class="row">
            <div class="col-1"></div>
            <div class="col-8">
              <b-form-group id="amountFieldGroup"
                            :label-cols="4"
                            breakpoint="md"
                            :state="stateForField('amount')"
                            :invalid-feedback="errorForField('amount')"
                            label="Amount"
                            label-class="text-right">
                <b-input-group prepend="$">
                  <b-form-input id="amountField" v-model="cashPayment.amount"></b-form-input>
                </b-input-group>
              </b-form-group>
              <b-form-group id="noteFieldGroup"
                            horizontal
                            :label-cols="4"
                            breakpoint="md"
                            :state="stateForField('cashNote')"
                            :invalid-feedback="errorForField('cashNote')"
                            label="Payment Note"
                            label-class="text-right">
                <b-input-group>
                  <b-form-input id="noteField" v-model="cashPayment.note"></b-form-input>
                </b-input-group>
              </b-form-group>
            </div>
          </div>
        </div>
      </b-form>
      <div slot="modal-footer" class="w-100">
        <button type="button" class="btn btn-orange float-right" @click.prevent="saveCashPayment()"><font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner"  pulse/>Process</button>
        <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
      </div>
    </b-modal>
</template>
<script>
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import api from '@/services/api'
  export default {
    name: 'VisitPaymentCashModal',
    mixins: [ErrorsMixin],
    props: {
      visible: {
        type: Boolean,
        required: true
      },
      visit: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        cashPayment: {
          amount: '',
          note: ''
        },
        visitPayment: {
          hasPaid: false,
          totalAmount: 0,
          TotalPaid: 0,
          discountAmount: 0,
          totalWithDiscount: 0,
          discount: {
            organizationOutstandingBalanceDiscountId: 0,
            endDate: null
          }
        },
        isSaving: false
      }
    },
    watch: {
      visible (newValue) {
        if (newValue) {
          this.setupDefaults()
          this.loadVisit()
        } else {
          this.clearAllErrors()
          this.clearData()
        }
      }
    },
    methods: {
      clearData () {
        this.clearAllErrors()
        this.cashPayment = {
          amount: '',
          note: ''
        }
      },
      validate () {
        this.clearAllErrors()
        const amountValue = this.cashPayment.amount
        const numericRegex = /^-?\d+(\.\d+)?$/
        if (!amountValue) {
          this.addErrorForField('amount', 'An amount is required.')
        }
        if (!numericRegex.test(amountValue)) {
          this.addErrorForField('amount', 'Please enter a valid number.')
        }
        if (amountValue <= 0) {
          this.addErrorForField('amount', 'Amount must be greater then zero.')
        }
        return !this.hasErrors()
      },
      loadVisit () {
        api.get('/Dashboard/Visit/' + this.visit.visitId + '/Payment').then(response => {
          this.trackEvent(this.$options.name, 'Load', 'ResponseTime', response.config.requestDuration)

          this.visitPayment = response.data
          this.setupDefaults()
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$store.logErrorResponse(this.$options.name, 'LoadError', error)
          }
        })
      },
      setupDefaults () {
        this.clearAllErrors()
        let total = this.visit.totalAmount
        if (this.visitPayment.discountAmount > 0) {
          total = this.visitPayment.totalWithDiscount
        }
        if ((total - this.visit.totalPaid) > 0) {
          this.cashPayment.amount = (total - this.visit.totalPaid).toFixed(2)
        } else {
          this.cashPayment.amount = total.toFixed(2)
        }

        this.discountedAmount = this.cashPayment.amount
      },
      saveCashPayment () {
        if (this.isSaving) {
          return
        }
        if (!this.validate()) {
          return
        }
        this.isSaving = true
        this.clearAllErrors()
        this.cashPayment.visitId = this.visit.visitId
        api.post('/Dashboard/Visit/CashPayment', this.cashPayment).then(response => {
          this.$emit('cashPaymentProcessed')
          this.isSaving = false
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to add cash payment: ' + error.message, error)
          }
          this.isSaving = false
        }).then(() => {
          this.isSaving = false
        })
      },
      closeModal () {
        this.$emit('update:visible', false)
      }
    }
  }
</script>
